import { normalizeFacetLabel } from './normalizeFacetLabel';

export const normalizeSidebarFacets = (state, payload = []) =>
  payload?.reduce(
    ({ allIds, byId }, facet) => {
      const label = normalizeFacetLabel(facet.label);
      const facetObject = {
        id: `grouplist:${label}`,
        label,
      };

      if (facet.children) {
        const childrenById = {};
        const generateChildrenAllIds = () => {
          if (label === 'subscriptions') {
            return facet.children.map(child => {
              childrenById[child.id] = {
                value: child,
                fields: { 'count()': null },
              };
              return child.id;
            });
          }
          if (label === 'user' || label === 'tags') {
            return facet.children.map(child => {
              childrenById[child.value] = child;
              return child.value;
            });
          }

          return facet.children.map(child => {
            childrenById[child] = {
              value: child,
              fields: { 'count()': null },
            };
            return child;
          });
        };

        const childrenAllIds = generateChildrenAllIds();

        facetObject.childrenAllIds = childrenAllIds;
        facetObject.childrenById = JSON.parse(JSON.stringify(childrenById));
      }

      return {
        byId: { ...byId, [label]: facetObject },
        allIds: allIds.includes(label) ? allIds : [...allIds, label],
      };
    },
    {
      byId: { ...state.sidebarFacets.byId },
      allIds: [...state.sidebarFacets.allIds],
    },
  );
